<template>
  <div class="container" v-if="loading">
    <div class="spinner"></div>
    <div class="message">{{InformationMessage}}</div>
  </div>
  <div v-else>
    <br/><br/>
    <div class="container">
      <h1>Manage Intermediary</h1>
      <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell small-12 margin-top-1">
        <br/>
        <p>The below users will have access to all onboarding projects linked to your intermediary account.</p>
        <p>If you wish to request a new user or a change to an existing user, please contact your Qtac account manager.</p>
      </div>
      <div class="cell small-12 margin-top-1">
        <h3>Manage Users for {{identity.intermediary.name}}</h3>
        <table>
            <thead>
                <tr>
                <th>Name</th>
                <th>Email Address</th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in intermediaryUsers" :key="user.id">                            
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td></td>
                </tr>
                    
            </tbody>
            </table>
      </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';

import { useIdentityStore } from '@/stores/identity';
import { getIntermediaryUsers } from '@/services/implementationmanagement.api';  

const identity = useIdentityStore();
const intermediaryUsers = ref([]);

var loading = ref(false);
var InformationMessage = ref('Loading your account...');



onMounted(async () => {
  InformationMessage.value = InformationMessage.value;


  try {
    const response = await getIntermediaryUsers(identity.intermediary.intermediaryId);
    if (response.status === 200) {
      intermediaryUsers.value = response.data;
    } else {
      InformationMessage.value = 'Error loading intermediary users.';
    }
  } catch (error) {
    InformationMessage.value = 'An unexpected error occurred while loading users.';
    console.error(error);
  } finally {
    loading.value = false;
  }
});



</script>
